import { actions, selectors } from '@sloyd/store-base';
import '@sloyd/types';
import { bridge } from '@sloyd/viewer';
import { delay, fork, put, select, takeEvery } from 'saga-ts';
import { invokeEvent, l } from 'shared-base';
import { generatorParametersToValuesModel } from '../utils/generators';
import { getWackDelta } from '../utils/randomize';
import { dataGuard } from './helpers/guards';

export const saga = {
  id: 'sloyd.values',
  type: 'entity',
  root: root,
  trigger: {
    actionTypes: ['VALUES'],
  },
};

type Verb = 'patch' | 'reset'; //

type Action = {
  type: 'VALUES';
  verb: Verb;
  id: string;
  payload: Json;
};

const map: Record<Verb, any> = {
  patch: patchValues,
  reset: resetValues,
};

export function* resetValues(action: Action, model: IModel) {
  try {
    const { generatorId, valuesModel } = model;
    const generator = yield* select(selectors.single.$generator, generatorId);
    const defaultWackValues = yield* select(selectors.parameters.$defaultWackValues);

    if (!generator) {
      throw new Error('No generator');
    }

    const { parameters } = generator;

    // only reset wack values if exist
    const extra = getWackDelta(valuesModel, defaultWackValues);
    const values = generatorParametersToValuesModel(parameters, extra);
    yield put(actions.valuesModel.patch(values));

    bridge.patchValuesModel('main', values);
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* patchValues(action: Action, model: IModel) {
  const { payload } = action;

  try {
    yield put(actions.valuesModel.patch(payload));
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}
export function* values(action: any) {
  const { verb, id } = action;
  yield delay(10);

  const saga = (map as any)[verb];

  if (!saga) {
    return;
  }

  l(`saga|saga.values ${verb} on ${id}`);

  yield* dataGuard();
  const model = yield* select(selectors.single.$currentModel);

  yield* fork(saga, action, model);
}

export function* root() {
  yield takeEvery('VALUES', values);
}
